<template>
  <v-row justify="center">
    <v-dialog persistent v-model="show">
      <v-row justify="center">
        <v-col cols="9" style="">
          <div
            id="receiptData"
            style="
              background: white;
              max-width: 800px;
              padding: 7px;
              margin-left: 28%;
            "
          >
            <body>
              <div id="page-wrap">
                <v-row
                  ><!-- top image -->
                  <v-col
                    cols="2"
                    lg="2"
                    xl="2"
                    md="2"
                    style="margin-left: 3%; margin-top: 0%"
                  >
                    <img
                      v-if="!imagelink"
                      style="height: 150px; width: 150px"
                      src="../../assets/img/nallai_logo.png"
                    />
                    <img
                      v-if="imagelink"
                      style="height: 150px; width: 150px"
                      :src="imagelink"
                    />
                  </v-col>
                  <!-- status -->

                  <!-- <v-col cols="4" lg="4" xl="4" md="4" style="margin-left:1%;">
                    <p
                      style="font-size:16px;
                    margin-top: 28%;"
                    >
                      <strong>
                        Status : {{ PurchaseOrderDetails.status }}
                      </strong>
                    </p>
                  </v-col> -->

                  <!-- Warehouse Component -->
                  <v-col
                    cols="5"
                    xl="5"
                    md="5"
                    lg="5"
                    style="margin-left: 4%; margin-top: 0%"
                  >
                    <p style="color: black; font-size: 13px"><b>Ship to:</b></p>

                    <b
                      v-if="
                        PurchaseOrderDetails && PurchaseOrderDetails.warehouse
                      "
                      style="color: black; font-size: 17px"
                    >
                      {{
                        PurchaseOrderDetails.warehouse.name
                          ? PurchaseOrderDetails.warehouse.name
                          : 'Warehouse'
                      }}</b
                    ><br />

                    <span style="color: black; font-size: 14px">
                      <strong>Address : </strong>
                      {{
                        PurchaseOrderDetails.warehouse.address
                          ? PurchaseOrderDetails.warehouse.address
                          : ''
                      }},
                      <br />
                      <strong> Phone No : </strong>
                      {{
                        PurchaseOrderDetails.warehouse.phone
                          ? PurchaseOrderDetails.warehouse.phone
                          : ''
                      }}.
                      <br />
                      <strong>Date : </strong>
                      {{ new Date().toLocaleString() }}.
                    </span>
                  </v-col>
                  <!-- Supplier component -->
                  <v-col
                    style="margin-left: 0%; margin-top: 0%"
                    cols="4"
                    xl="4"
                    md="4"
                    lg="4"
                  >
                    <p style="color: black; font-size: 13px"><b>Vender:</b></p>
                    <b style="color: black; font-size: 17px">
                      {{
                        Suppliers.contact[0].full_name
                          ? Suppliers.contact[0].full_name
                          : 'Supplier Name'
                      }}
                    </b>
                    <br />
                    <span style="color: black; font-size: 14px">
                      <strong>Address : </strong>
                      {{
                        Suppliers.addresses[0].address_line1
                          ? Suppliers.addresses[0].address_line1
                          : '-----'
                      }}, {{ Suppliers.addresses[0].city }},
                      {{ Suppliers.addresses[0].postal_code }}.
                      <br />
                      <strong> Invoice No : </strong>
                      {{
                        PurchaseOrderDetails.reference_number
                          ? PurchaseOrderDetails.reference_number
                          : '-----'
                      }}
                      <br />
                      <strong>Date : </strong>
                      {{
                        PurchaseOrderDetails.date
                          ? PurchaseOrderDetails.date
                          : '-----'
                      }}
                    </span>
                  </v-col>
                </v-row>

                <!-- Products Table -->
                <table class="table" style="margin-top: 4%">
                  <thead>
                    <tr>
                      <th colspan="4" style="color: black"><b>Products</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="thead" style="font-weight: bold">
                      <td>Product Code</td>
                      <td>Product Name</td>
                      <td>Unit</td>
                      <td>Qty</td>
                    </tr>
                    <tr v-for="(item, index) in ProductData" :key="index">
                      <td v-if="item">{{ item.code }}</td>
                      <td v-if="item">
                        {{ item.name }}
                      </td>
                      <td v-if="item && item.unit">{{ item.unit.name }}</td>
                      <td>{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
                <p style="page-break-after: auto"></p>
                <div style="page-break-inside: avoid">
                  <!-- prepared by -->
                  <v-row>
                    <v-col
                      cols="6"
                      lg="6"
                      xl="6"
                      md="6"
                      style="margin-left: 3%; margin-top: 5%"
                    >
                      ---------------------------------- <br />
                      <p style="color: black; font-size: 13px">Prepared By</p>
                    </v-col>
                    <v-col
                      cols="5"
                      lg="5"
                      xl="5"
                      md="5"
                      style="margin-top: 5%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Date</p>
                    </v-col>
                  </v-row>
                  <!-- Authorized by -->
                  <v-row>
                    <v-col
                      cols="11"
                      lg="11"
                      xl="11"
                      md="11"
                      style="margin-left: 3%; margin-top: 2%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Authorized By</p>
                    </v-col>
                  </v-row>
                </div>
                <!-- bottom component -->
                <div style="text-align: center; bottom: 10px; margin-top: 5%">
                  <p style="font-weight: bold">Thank You</p>
                  <p style="bottom: 10px">
                    Powered by &#169;www.speedcodelabs.com || &#9742; 0212211599
                  </p>
                </div>
                <p style="page-break-after: always"></p>
              </div>
            </body>
          </div>
        </v-col>
        <!-- Print, mail , close component -->
        <v-col cols="3">
          <v-row>
            <v-col cols="12">
              <v-btn height="32" width="160" outline @click="openPrint">
                <v-icon class="icon_small mr-2" dark>print</v-icon>Print
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn height="32" width="160" outline disabled>
                <v-icon class="icon_small mr-2" dark>mail</v-icon> Mail
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                height="32"
                width="160"
                color="red"
                outline
                @click="closePreview"
              >
                <v-icon class="icon_small mr-2" style="color: white" dark
                  >close</v-icon
                ><span style="color: white"> Close </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ReservationDetails: [],
      dialog: false,
      value: [],
      options: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['imagelink']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.PurchaseOrderDetails);
        }
      },
    },
  },
  mounted() {
    this._keyListener = function (e) {
      if (e.key == 'Escape') {
        this.$emit('closePreview');
      }
    };

    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },
  props: {
    ProductData: {
      type: Array,
      default: [],
    },

    PurchaseOrderDetails: {
      type: Object,
      default: {},
    },
    WarehouseData: {
      type: Object,
      default: {},
    },
    Suppliers: {
      type: Object,
      default: {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    TotalAdditionalAmount: 0,
    SubTotal: 0,
    ProductDiscount: 0,
  },
  methods: {
    closePreview() {
      this.$emit('closePreview');
    },
    openPrint() {
      this.$htmlToPaper('receiptData');
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`;
      return date;
    },
    GetPurchaseStatusColor(status) {
      switch (status) {
        case 'Completed':
          return green;
          break;
        case 'Pending':
          return orange;
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
table {
  margin: 40px 0px;
  font-size: 1rem;
  color: rgb(0, 0, 0);
  font-weight: 700;
  /* border: 1px solid rgb(0, 0, 0); */
  background-color: #fff;
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;
}

table thead {
  background-color: rgb(0, 0, 0);
  font-size: 2rem;
  color: #fff;
  letter-spacing: 0.3rem;
}

table td,
table th {
  /* border-bottom: 1px solid rgb(7, 7, 7) !important; */
  height: 60px;
  width: calc(100% / 4);
  vertical-align: middle !important;
}

.thead {
  font-weight: 900;
}

table thead th + th,
table tbody td {
  /* border-right: 1px solid #333 !important; */
}

table tbody td:nth-child(6) {
  border-right: none;
}

table th {
  font-size: 14px;
}

table td,
table th {
  height: 50px;
}
.example {
  background-color: #eee;
  width: 200px;
  height: 100px;
  border: 1px dotted black;
  overflow-y: scroll; /* Add the ability to scroll */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
